export default __webpack_public_path__ + "static/images/plugin-mi.png?cb6ac0cb700a797342ebb25d7b4244a6";